export const Families = [
  {
    name: 'Virgin',
    image: 'https://i.pinimg.com/236x/2e/63/c8/2e63c82dfd49aca8dccf9de3f57e8588.jpg',
  },
  {
    name: 'Nelson',
    image: 'https://i.pinimg.com/236x/25/14/29/251429345940a47490cc3d47dfe0a8eb.jpg',
  },
  {
    name: 'others',
    image: 'https://i.pinimg.com/236x/2e/63/c8/2e63c82dfd49aca8dccf9de3f57e8588.jpg',
  },
];

export const familyQuery = (userId) => {
  const query = `*[_type == "family" && users[]->_id match [${userId}] ]{
    _id,
    familyName,
    "imageUrl": image.asset->url,
  }`;

  return query;
}

export const feedQuery = (userId) => {
  const query = `*[(_type == "conversation" || _type == "pin" || _type == "vid") && references(*[${userId} in users[]._ref]._id)]  | order(_createdAt desc){
    image{
      asset->{
        url
      }
    },
    video,
    _type,
    title,
    _id,
    body,
    postedBy->{
      _id,
      userName,
      image,
      "profUrl": profImage
    },
    "familyName": family[]->familyName,
  }`;

  return query;
}



// export const feedQuery = (familyArray) => {
//   const query = `*[(_type == "conversation" || _type == "pin") && (${familyArray})] | order(_createdAt desc) {
//   image{
//     asset->{
//       url
//     }
//   },
//   _type,
//   title,
//   _id,
//   body,
//   postedBy->{
//     _id,
//     userName,
//     image
//   },
// }`;

//   return query;
// }


export const pinDetailQuery = (pinId) => {
  const query = `*[_type == "pin" && _id == '${pinId}']{
    image{
      asset->{
        url
      }
    },
    _type,
    _id,
    title, 
    body,
    postedBy->{
      _id,
      userName,
      "image": profImage,
      "profUrl": profImage
    },
    comments[]{
      comment,
      _key,
      postedBy->{
        _id,
        userName,
        image,
        "profUrl": profImage
      },
    }
  }`;
  return query;
};

export const vidDetailQuery = (pinId) => {
  const query = `*[_type == "vid" && _id == '${pinId}']{
    video,
    _type,
    _id,
    title, 
    body,
    postedBy->{
      _id,
      userName,
      "image": profImage,
      "profUrl": profImage
    },
    comments[]{
      comment,
      _key,
      postedBy->{
        _id,
        userName,
        image,
        "profUrl": profImage
      },
    }
  }`;
  return query;
};

export const convoDetailQuery = (conId) => {
  const query = `*[_type == "conversation" && _id == '${conId}']{
    _id,
    title, 
    body,
    category,
    postedBy->{
      _id,
      userName,
      image,
      "profUrl": profImage,
    },
    comments[]{
      comment,
      _key,
      postedBy->{
        _id,
        userName,
        image,
        "profUrl": profImage,
      },
      timeStamp,
    }
  }`;
  return query;
};

export const commentQuery = (id) =>{
  const query = `*[_id=="${id}"].comments[]{
    comment,
    _key,
    postedBy->{
      _id,
      userName,
      image,
      "profUrl": profImage,
    },
  }`;

  return query;
}

export const conDetailMoreConQuery = (pin) => {
  const query = `*[_type == "conversation" && category == '${pin.category}' && _id != '${pin._id}' ]{
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image,
      "profUrl": profImage
    },
    save[]{
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};


export const searchQuery = (searchTerm) => {
  const query = `*[(_type == "conversation" || _type == "pin" || _type == "vid") && (family[]->_id match '${searchTerm}*')] | order(_createdAt desc){
    image{
      asset->{
        url
      }
    },
    video,
    _type,
    _id,
    title,
    body,
    postedBy->{
      _id,
      userName,
      image,
      "profUrl": profImage
    },
    "familyName": family[]->familyName,
  }`;
  return query;
};

export const searchPinQuery = (searchTerm, id) => {
  const query = `*[(_type == "conversation" || _type == "pin" || _type == "vid") && (family match '${searchTerm}*' || title match '${searchTerm}*' || body match '${searchTerm}*' || postedBy->userName match '${searchTerm}*') && references(*['${id}' in users[]._ref]._id)]{
        image{
          asset->{
            url
          }
        },
        video,
        _type,
        _id,
        title,
        body,
        postedBy->{
          _id,
          userName,
          image,
          "profUrl": profImage,
        },
        "familyName": family[]->familyName,
      }`;
  return query;
};

export const searchConQuery = (searchTerm) => {
  const query = `*[_type == "conversation" && family match '${searchTerm}*']{
    title,
    _id,
    body,
    postedBy->{
      _id,
      userName,
      image,
      "profUrl": profImage
    },
  }`;
  return query;
};

export const userQuery = (userId) => {
  const query = `*[_type == "user" && _id == '${userId}']{
    _id,
    image,
    userName,
    "profUrl": profImage,
    "banUrl": bannerImage,
    email,
    phoneNumber,
    birthday,
    address,
    notifications,
  }`;

  return query;
};

export const getNotifications = (userId) => {

  const query =`*[_type == "user" && _id == '${userId}']{
    notifications,
  }`;
  return query;
  
}

export const familyDetailQuery = (_id) => {
  const query = `*[_type == "family" && _id == '${_id}']{
    _id,
    familyName,
    "imageUrl": image.asset->url,
    admin->{
    userName,
    _id,
    },
    users[]{
      "userId": _ref,
      "user": *[_type=='user' && _id match ^._ref]{userName, "profUrl": profImage, _id},
    },
    requests[]{
      "user" : *[_type=='user' && _id match ^._ref]{userName, image, _id},
    },
  }`;

  return query;
};

export const userCreatedPinsQuery = (userId) => {
  const query = `*[ (_type == "conversation" || _type == "pin" || _type == "vid") && userId == '${userId}' ] | order(_createdAt desc){
    image{
      asset->{
        url
      }
    },
    video,
    _type,
    _id,
    title,
    body,
    postedBy->{
      _id,
      userName,
      image,
      "profUrl": profImage
    },
    "familyName": family[]->familyName,
  }`;
  return query;
};

export const userCreatedPinsQueryNonUser = (userId, nonUserId) => {
  const query = `*[ (_type == "conversation" || _type == "pin" || _type == "vid") && userId == '${userId}' && references(*[${nonUserId} in users[]._ref]._id)] | order(_createdAt desc){
    image{
      asset->{
        url
      }
    },
    video,
    _type,
    _id,
    title,
    body,
    postedBy->{
      _id,
      userName,
      image,
      "profUrl": profImage
    },
    "familyName": family[]->familyName,
  }`;
  return query;
};

// export const userSavedPinsQuery = (userId) => {
//   const query = `*[_type == 'pin' && '${userId}' in save[].userId ] | order(_createdAt desc) {
//     image{
//       asset->{
//         url
//       }
//     },
//     _id,
//     destination,
//     postedBy->{
//       _id,
//       userName,
//       image,
//       "profUrl": profImage
//     },
//     save[]{
//       postedBy->{
//         _id,
//         userName,
//         image
//       },
//     },
//   }`;
//   return query;
// };

export const familySearchQuery = (family) =>{
  const query = `*[_type=='family' && familyName match '${family}*']{
    _id,
    familyName,
    "imageUrl": image.asset->url,
    admin->{
    userName,
    _id,
    }
  }`;
  return query;
};
